const liveURL = 'https://amazon-clone-rgx4.onrender.com/'
const devURL = 'http://localhost:5000/'
const prod = true

export let url = prod ? liveURL : devURL
